const BASE_URL = (
  process.env.REACT_APP_INVENTORY_API_URL || 'https://dev-agent.savictech.com/inventory'
).replace(/\/$/, '');

async function apiFetch(path, options = {}) {
  try {
    return await fetch(`${BASE_URL}${path}`, options);
  } catch (err) {
    throw new Error(
      `Cannot connect to Inventory API at ${BASE_URL}. ` +
      'Set REACT_APP_INVENTORY_API_URL to your API server.'
    );
  }
}

async function handleResponse(res) {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      if (data.error) {
        detail = data.error;
      } else if (Array.isArray(data.detail)) {
        detail = data.detail
          .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' -> ') : e.loc}] ${e.msg}`)
          .join(' | ');
      } else if (typeof data.detail === 'string') {
        detail = data.detail;
      } else {
        detail = JSON.stringify(data);
      }
    } catch (_) {}
    throw new Error(detail);
  }
  return res.json();
}

function buildQs(params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== '' && v !== undefined && v !== null)
  );
  const qs = new URLSearchParams(clean).toString();
  return qs ? `?${qs}` : '';
}

// GET /api/v1/materials
export const getMaterials = () =>
  apiFetch('/api/v1/materials').then(handleResponse);

// GET /api/v1/stock-prediction?material_id=MAT001&plant=1000
export const getStockPrediction = (materialId, plant) =>
  apiFetch(`/api/v1/stock-prediction${buildQs({ material_id: materialId, plant })}`).then(handleResponse);

// GET /api/v1/alerts?limit=100&risk=HIGH&plant=1301
export const getAlerts = ({ limit, risk, plant } = {}) =>
  apiFetch(`/api/v1/alerts${buildQs({ limit, risk, plant })}`).then(handleResponse);

// GET /api/v1/forecast-demand?material_id=MAT001&weeks=12
export const getForecastDemand = (materialId, weeks) =>
  apiFetch(`/api/v1/forecast-demand${buildQs({ material_id: materialId, weeks })}`).then(handleResponse);

// GET /api/v1/auto-procurement?limit=100
export const getAutoProcurement = ({ limit } = {}) =>
  apiFetch(`/api/v1/auto-procurement${buildQs({ limit })}`).then(handleResponse);

// POST /api/v1/create-po (no body — auto-creates POs for all HIGH/MEDIUM risk)
export const createPurchaseOrder = () =>
  apiFetch('/api/v1/create-po', { method: 'POST' }).then(handleResponse);

// POST /api/v1/create-po-manual
export const createPOManual = (material_id, plant, vendor, quantity) =>
  apiFetch('/api/v1/create-po-manual', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ material_id, plant, vendor, quantity }),
  }).then(handleResponse);

// GET /api/v1/get-po
export const getPurchaseOrders = () =>
  apiFetch('/api/v1/get-po').then(handleResponse);

// GET /api/v1/production-status
export const getProductionStatus = () =>
  apiFetch('/api/v1/production-status').then(handleResponse);
